import React from 'react';
import { Box, IconButton, Tooltip } from '@material-ui/core';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import RestoreIcon from '@material-ui/icons/Restore';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTranslation } from 'react-i18next';
import { InfoButton } from '../../FormWidgets/Description';

export function historyZoomOptions(onRangeChange, { mode = 'x', pan = false,
  pinch = Boolean(onRangeChange), drag = true, onStart, onProgress, onComplete, minRange = 60000, bounds } = {}) {
  const complete = onComplete ?? (({ chart }) => onRangeChange?.(chart.scales.x.min, chart.scales.x.max));
  const enabled = Boolean(onRangeChange || onComplete);
  return {
    limits: { x: { minRange, ...bounds } },
    pan: { enabled: pan, mode, modifierKey: 'shift', onPanStart: onStart, onPan: onProgress, onPanComplete: complete },
    zoom: { mode, wheel: { enabled: false }, pinch: { enabled: pinch },
      drag: { enabled: enabled && drag, threshold: 10, backgroundColor: '#9bc31c33', borderColor: '#9bc31c', borderWidth: 1 },
      onZoomStart: onStart, onZoom: onProgress, onZoomComplete: complete }
  };
}

export default function HistoryZoom({ range, onChange, onReset, canReset }) {
  const { t } = useTranslation();
  const span = range.to - range.from, center = (range.to + range.from) / 2;
  const controls = [
    ['database_previous_period', ChevronLeftIcon, () => onChange(range.from - span / 2, range.to - span / 2)],
    ['database_zoom_in', ZoomInIcon, () => onChange(center - span / 4, center + span / 4), span <= 60000],
    ['database_zoom_out', ZoomOutIcon, () => onChange(center - span, center + span), span >= 180 * 86400000],
    ['database_reset_zoom', RestoreIcon, onReset, !canReset],
    ['database_next_period', ChevronRightIcon, () => onChange(range.from + span / 2, range.to + span / 2)]
  ];
  return <Box display="flex" alignItems="center" role="group" aria-label={t('database_zoom')}>
    {controls.map(([label, Icon, action, disabled]) => <Tooltip key={label} title={t(label)}><span>
      <IconButton size="small" style={{ minWidth: 40, minHeight: 40 }} aria-label={t(label)} disabled={disabled} onClick={action}><Icon /></IconButton>
    </span></Tooltip>)}
    <InfoButton brief={t('database_zoom')} content={t('database_zoom_help')} />
  </Box>;
}
